import React, { useMemo, useCallback } from 'react';

import {useDropzone} from 'react-dropzone'

function validateR1R2Suffix(file) {
    if (
        file.name.match(/_(R?[12])(_001)?\.fastq\.gz$/)
    ) {
        return null
    }

    return {
        "message": "File names must contain _1, _2, _R1, or _R2 suffix, optionally followed by _001"
    }
}

function FileDropZone(props) {
    const { isIllumina, addStagedFile } = props;

    const onDrop = useCallback(acceptedFiles => {
        for (let file of acceptedFiles) addStagedFile(file)
    }, [addStagedFile])

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({
        onDrop, 
        'accept': {'application/gzip': ['.fastq.gz'], 'application/x-gzip': ['.fastq.gz']},
        validator: isIllumina ? validateR1R2Suffix : null
    })

    const style = useMemo(() => {
        const dropZoneStyle = {
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              padding: '20px',
              borderWidth: 2,
              borderRadius: 2,
              borderColor: '#eeeeee',
              borderStyle: 'dashed',
              backgroundColor: '#fafafa',
              color: '#bdbdbd',
              cursor: "pointer",
              outline: 'none',
              transition: 'border .24s ease-in-out'
        };
        const focusedStyle = { borderColor: '#2196f3' };
        const acceptStyle = { borderColor: '#00e676' };
        const rejectStyle = { borderColor: '#ff1744' };

        return {
            ...dropZoneStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }
    }, [ isFocused, isDragAccept, isDragReject ]);

    return <div {...getRootProps()} style={style}>
        <input {...getInputProps()} />
        <p style={{fontSize: 15}}>
            <b>Click to open browser or drag/drop sequencing files</b>
            <br/>
            Files must be Gzip compressed with {isIllumina ? '_1/R1.fastq.gz or _2/R2.fastq.gz' : '.fastq.gz'} suffix
            {isIllumina ? 
                (
                    <>
                    <br/>Filenames with suffixes like _R[1|2]_001.fastq.gz are also accepted

                    <br/>
                    Paired sequencing files must have the same file name prior to _1/R1 or _2/R2 suffix
                    </>
                ):
                null
            }
        </p>
    </div>
}

export default FileDropZone;